import { jsx as _jsx } from "react/jsx-runtime";
export default function XShareButton(_ref) {
  let {
    text,
    url,
    hashtags,
    via,
    children
  } = _ref;
  /**
   * twiterのシェアボタン
   * @param {Object} props
   * @param {String} props.text - ツイート本文
   * @param {String} props.url - ツイートに含めるURL
   * @param {String} props.hashtags - ハッシュタグ
   * @param {String} props.via - ツイートに含めるユーザー名
   * @param {React.element} props.children - このコンポーネントで括った親コンポーネントのDOM
   */
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  const encodedHashtags = encodeURIComponent(hashtags);
  function subWindow(url) {
    const width = 550;
    const height = 400;
    const centerX = window.screenX + window.outerWidth / 2;
    const centerY = window.screenY + window.outerHeight / 2;
    const left = Math.round(centerX - width / 2);
    const top = Math.round(centerY - height / 2);
    window.open(url, "share window", `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`);
  }
  return /*#__PURE__*/_jsx("div", {
    onClick: () => {
      subWindow(`https://x.com/intent/tweet?text=${encodedText}&url=${encodedUrl}&hashtags=${encodedHashtags}`);
    },
    children: children
  });
}